import useSWR from 'swr';

export const usePETIs = (id) => useSWR(`OrganizationRoles/fleets/${id}/petis`);